import reducer from "./reducer";
export { default as MyTraining } from "./components/index";
export { default as myTrainingReducerName } from "./constants";
export default reducer;
